import { HrmServiceAllowDto, defaultHrmServiceAllowDto } from "src/dtos/hrmServiceAllow/hrmServiceAllowDto";
import { HrmPositionAllowDto, defaultHrmPositionAllowDto } from "src/dtos/hrmPositionAllow/hrmPositionAllowDto";
import { EmployeeDto, defaultEmployee } from "src/dtos/employee/employeeDto";

/** 두 기준표 조회 응답과 한 번의 저장 요청 목록이다. */
export interface HRM3040_R01Dto {
    hrmServiceAllowDtoList: HRM3040_R01ServiceAllowDto[]; // 근속 조회 또는 신규·수정 행
    hrmPositionAllowDtoList: HRM3040_R01PositionAllowDto[]; // 직책 조회 또는 신규·수정 행
    deletedHrmServiceAllowDtoList: HRM3040_R01ServiceAllowDto[]; // 근속 삭제 행
    deletedHrmPositionAllowDtoList: HRM3040_R01PositionAllowDto[]; // 직책 삭제 행
}
/** 근속 기준은 엔티티 DTO를 그대로 상속한다. */
export interface HRM3040_R01ServiceAllowDto extends HrmServiceAllowDto {}
/** 직책 기준은 엔티티 DTO를 그대로 상속한다. */
export interface HRM3040_R01PositionAllowDto extends HrmPositionAllowDto {}
/** 사원 마스터에 서버 계산 결과만 추가한 미리보기 행이다. */
export interface HRM3040_R01PreviewDto extends EmployeeDto {
    orgNm: string; // 최신 부서명
    serviceYears: number; // 입사일 기준 만 근속년수
    serviceAllowAmt: number; // 근속수당 월액
    positionAllowAmt: number; // 직책수당 월액
    totalAllowAmt: number; // 두 수당 월액 합계
}
/** 조회 전·빈 저장 목록의 기본값이다. */
export const defaultHRM3040_R01Dto: HRM3040_R01Dto = {
    hrmServiceAllowDtoList: [], hrmPositionAllowDtoList: [],
    deletedHrmServiceAllowDtoList: [], deletedHrmPositionAllowDtoList: [],
};
/** 펼치기: 엔티티 DTO의 모든 기본 필드를 복사한다. */
export const defaultHRM3040_R01ServiceAllowDto: HRM3040_R01ServiceAllowDto = { ...defaultHrmServiceAllowDto };
/** 직책 엔티티 기본값을 모두 포함한다. */
export const defaultHRM3040_R01PositionAllowDto: HRM3040_R01PositionAllowDto = { ...defaultHrmPositionAllowDto };
/** 사원 기본 필드와 계산 결과 기본값을 모두 포함한다. */
export const defaultHRM3040_R01PreviewDto: HRM3040_R01PreviewDto = {
    ...defaultEmployee, orgNm: '', serviceYears: 0, serviceAllowAmt: 0, positionAllowAmt: 0, totalAllowAmt: 0,
};
